export interface PageText {
    title?: string;
    content?: string[];
    buttonText?: string;
}

// 구독 정보 영역
export const SUBSCRIPTION_INFORMATION_TEXT: PageText = {
    content: ['구독 중단으로 변화리포트 생성이 중단되었습니다.', '과거 생성된 리포트는 계속 열람 가능합니다.'],
    buttonText: 'InBody+ PRO 안내페이지로',
};

export const PRO_REPORT_WAITING_FIRST_REPORT_TEXT: string = `
<b>'변화리포트'</b>은 #NAME#님의 1개월 체성분 변화를 분석한 인바디 보고서입니다. 분석에는 PRO1:Trainer 모델이 사용되며 인바디의 임상전문가가 모든 리포트를 확인하고 첨삭하여 발행됩니다.\n 정확한 분석을 위해 매일 검사가 추천되며, <p class="underlineT">발급 최소 조건은 7일 당 4일 이상의 검사가 2주 연속 필요</p>합니다. 최소 조건이므로 모든 기간에 해당 조건을 만족하시는 것이 좋습니다.\n매주 4회 이상의 검사를 진행하여 '변화리포트'을 발행받고, 1년에 12회 '변화리포트'을 받아 연간리포트를 완성하세요.`;
